import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/pick-city-background.jpeg'


const _hoisted_1 = { class: "app-content" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Merci de mettre à jour l'application. ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Ouvrir le Store ")
const _hoisted_4 = {
  key: 3,
  class: "d-flex align-center justify-center",
  style: {"width":"100%"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" hors ligne ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Vous êtes hors ligne. Les offres affichées ne sont peut êtres plus à jour. Essayez de redémarrez l'application pour vous reconnecter. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("fas fa-check")

import { Ref, computed, provide, ref } from "vue";
import { useRoute } from "vue-router";
import { Partner, Event } from "@emblem/api";
import { City, CityNames } from "@emblem/common";
import { setNotificationCityIfPossible } from "./notifications";


import { defineComponent } from "vue";
import {
  backupContent,
  provideContent,
  restoreContent,
} from "./helpers/content";
import { getStore, saveStore } from "./emblem-store";
import { watch } from "vue";
import { ComputedRef } from "vue";
import { setReloadContentHandler } from "./helpers/content";
import { requiresUpdate, openAppStore } from "./helpers/updates";

const __default__ = defineComponent({
  name: "App",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const cities = Object.keys(CityNames).map(((id: City) => ({
  id,
  name: CityNames[id],
})) as (id: string) => { id: City; name: string });

const loaded = ref(false);
const needsToPickCity = ref(false);
const city = ref<City | null>(null);

async function waitForCity() {
  if (city.value) return;
  await new Promise((resolve) => setTimeout(resolve, 100));
  await waitForCity();
}

// very important to call provideContent here
// otherwise we'll get "provide() can only be used inside setup()"
const loadPartners = provideContent("partners", Partner, (a, b) =>
  a.name.localeCompare(b.name, undefined, {
    sensitivity: "base",
  })
);
const loadEvents = provideContent(
  "events",
  Event,
  (a, b) => b.end.getTime() - a.end.getTime()
);
provide<Ref<City>>("city", city as Ref<City>); // once loaded, city can't be null
provide<ComputedRef<string>>(
  "city:logo",
  computed(() =>
    city.value ? `/img/logo-${city.value.toLowerCase()}.png` : "/img/logo.png"
  )
);

watch(city, async (city) => {
  // when city changes, we need to save it to the store and reload partners and events
  if (city) {
    if (needsToPickCity.value || loaded.value) {
      console.log("city changed", city);
      // city was changed by user
      (await getStore()).city = city;
      await saveStore();
      // FIXME: shouldn't we re-subscribe more often if token changes ?
      void setNotificationCityIfPossible(city);
      // TODO: reload content
    }
  }
});

const isOffline = ref(false);

function promiseWithTimeout<T>(
  promise: Promise<T>,
  ms: number,
  timeoutError = new Error("Promise timed out")
): Promise<T> {
  // create a promise that rejects in milliseconds
  const timeout = new Promise<never>((_, reject) => {
    setTimeout(() => {
      reject(timeoutError);
    }, ms);
  });

  // returns a race between timeout and the passed promise
  return Promise.race<T>([promise, timeout]);
}

async function load() {
  loaded.value = false;
  city.value = (await getStore()).city;
  if (!city.value) {
    needsToPickCity.value = true;
    await waitForCity();
    needsToPickCity.value = false;
  }
  try {
    await Promise.all([
      promiseWithTimeout(loadPartners(), 5000),
      promiseWithTimeout(loadEvents(), 5000),
    ]);
    await backupContent();
  } catch (e) {
    console.error("failed to load content", e);
    isOffline.value = true;
    await restoreContent();
  } finally {
    loaded.value = true;
  }
}
setReloadContentHandler(load);

const updateIsRequired = ref(false);
async function init() {
  try {
    // FIXME: this should not fail on android
    updateIsRequired.value = await requiresUpdate();
    console.log(`update is ${updateIsRequired.value ? "" : "not "}required`);
  } catch (error) {
    console.error("failed to check for updates", error);
    updateIsRequired.value = false;
  }
  await load();
}
init();

const route = useRoute();

const menuItems = [
  { path: "/offers", icon: "fa-solid fa-shop" },
  { path: "/events", icon: "$events" },
  { path: "/home", icon: "fa-solid fa-home" },
  { path: "/ski", icon: "fa-solid fa-person-skiing" },
  { path: "/about", icon: "fa-solid fa-circle-info" },
];
const activeMenuItem = computed(() =>
  menuItems.findIndex(({ path }) => path == route.path)
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, {
        style: {"display":"flex"},
        class: _normalizeClass({ loading: !loaded.value })
      }, {
        default: _withCtx(() => [
          (loaded.value)
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 0,
                fluid: "",
                class: "pa-0",
                style: {"position":"relative"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_router_view)
                  ])
                ]),
                _: 1
              }))
            : (needsToPickCity.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 1,
                  fluid: "",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _imports_0,
                      style: {"position":"absolute","top":"0","left":"0","right":"0","bottom":"0"},
                      cover: ""
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cities), (_city, i) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            key: i,
                            cols: "6",
                            md: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                onClick: ($event: any) => (city.value = _city.id),
                                style: {"max-height":"30vh"},
                                class: "d-flex flex-column"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_img, {
                                    src: `/img/logo-${_city.id.toLowerCase()}.png`,
                                    class: "flex-shrink-1"
                                  }, null, 8, ["src"]),
                                  _createVNode(_component_v_card_title, { class: "text-center" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_city.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (updateIsRequired.value)
                ? (_openBlock(), _createBlock(_component_v_container, {
                    key: 2,
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_actions, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                onClick: _unref(openAppStore),
                                block: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary",
                      size: "100"
                    })
                  ]))
        ]),
        _: 1
      }, 8, ["class"]),
      (loaded.value)
        ? (_openBlock(), _createBlock(_component_v_bottom_navigation, {
            key: 0,
            value: _unref(activeMenuItem),
            color: "primary",
            style: _normalizeStyle({ height: 'calc(56px + env(safe-area-inset-bottom))' })
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
                return _createVNode(_component_v_btn, {
                  key: item.path,
                  to: item.path
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: item.icon
                    }, null, 8, ["icon"])
                  ]),
                  _: 2
                }, 1032, ["to"])
              }), 64))
            ]),
            _: 1
          }, 8, ["value", "style"]))
        : _createCommentVNode("", true),
      (isOffline.value)
        ? (_openBlock(), _createBlock(_component_v_dialog, { key: 1 }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_footer, _mergeProps({
                absolute: "",
                app: "",
                color: "error",
                class: "justify-center"
              }, props), {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1040)
            ]),
            default: _withCtx(({ isActive }) => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        color: "success",
                        onClick: ($event: any) => (isActive.value = false)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})